import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { EmailNotificationService } from '../email-notification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from 'src/app/login.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-email-notification-create',
  templateUrl: './email-notification-create.component.html',
  styleUrls: ['./email-notification-create.component.css']
})
export class EmailNotificationCreateComponent implements OnInit {

  emailNotificationForm: FormGroup;
  emailNotificationId: string | null = null;
  userData: any;

  constructor(
    private fb: FormBuilder,
    private emailNotificationService: EmailNotificationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private loginService: LoginService

  ) {

    this.emailNotificationForm = this.fb.group({
      name: ["", Validators.required],
      notification_type: ["", Validators.required],
      notification_frequency: [""],
      notification_day: [{ value: null, disabled: true }],
      notification_time: [""],
      report: [""],
      email_address: [""],
      enabled: [true]
    });

  }

  ngOnInit() {
    this.userData = this.loginService.getUserdata(true)
    this.emailNotificationId = this.activatedRoute.snapshot.paramMap.get("id");
    this.initializeForm();

  }

  initializeForm() {
    if (this.emailNotificationId) {
      this.emailNotificationService.getEmailNotificaion(this.emailNotificationId).subscribe((res: any) => {
        if (res.status === "1") {
          const data = res.data

          const notificationDayControl = this.emailNotificationForm.get('notification_day')

          this.emailNotificationForm.patchValue({
            name: data.name,
            notification_type: data.notification_type,
            notification_frequency: data.notification_frequency,
            notification_day: data.notification_day,
            notification_time: data.notification_time,
            report: data.report,
            email_address: data.email_address,
            enabled: data.enabled
          });

          if (["2", "3", 2, 3].includes(data.notification_frequency)) {
            notificationDayControl.enable();
          } else {
            notificationDayControl.disable();
          }
        }
      })
    }
  }

  onSubmit() {
    this.markFormGroupAsTouched(this.emailNotificationForm);
    this.validateControls();
    if (this.emailNotificationForm.valid) {

      if (!this.validateEmails()) {
        return
      }

      const data = {
        id: this.emailNotificationId,
        user_profile: this.userData.id,
        ...this.emailNotificationForm.value,
      }



      if (this.emailNotificationId) {
        this.emailNotificationService.updateEmailNotification(data).subscribe((res: any) => {
          if (res.status === "1") {
            Swal.fire("Success", "Email notification updated successully.", "success");
            this.router.navigate(["email-notification-list"])
          } else {
            Swal.fire("Something went wrong!", "Failed to update email notification.", "error");
          }
        })

      } else {
        this.emailNotificationService.createEmailNotification(data).subscribe((res: any) => {
          if (res.status === "1") {
            Swal.fire("Success", "Email notification created successully.", "success");
            this.router.navigate(["email-notification-list"])
          } else {
            Swal.fire("Something went wrong!", "Failed to create email notification.", "error");
          }
        })
      }

    } else {
      console.log("Errors in form", this.emailNotificationForm.errors);

    }
  }

  validateControls() {
    const notificationType = this.emailNotificationForm.value.notification_type;
    const notificationFrequency = this.emailNotificationForm.value.notification_frequency;

    const notificationFrquencyControl = this.emailNotificationForm.get("notification_frequency");
    const notificatioDayControl = this.emailNotificationForm.get("notification_day");
    const emailAddressControl = this.emailNotificationForm.get("email_address");
    const notificationTimeControl = this.emailNotificationForm.get("notification_time");
    const reportControl = this.emailNotificationForm.get("report");

    if (notificationType == "1") {
      notificationFrquencyControl.setValidators([Validators.required]);
      emailAddressControl.setValidators([Validators.required]);
      notificationTimeControl.setValidators([Validators.required]);
      reportControl.setValidators([Validators.required]);
    } else {
      notificationFrquencyControl.clearValidators();
      emailAddressControl.clearValidators();
      notificationTimeControl.clearValidators()
      reportControl.clearValidators();
    }

    if (notificationFrequency == "2") {
      notificatioDayControl.setValidators([Validators.required]);
    } else {
      notificatioDayControl.clearValidators();
    }

    notificationFrquencyControl.updateValueAndValidity();
    notificatioDayControl.updateValueAndValidity();
    emailAddressControl.updateValueAndValidity();
    notificationTimeControl.updateValueAndValidity();
    reportControl.updateValueAndValidity();

  }

  markFormGroupAsTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(controlName => {
      const control = formGroup.get(controlName);

      if (control instanceof FormGroup) {
        this.markFormGroupAsTouched(control);
      } else {
        control.markAsTouched();
      }
    });
  }

  onNotificationFrequencyChange() {
    const notificationDayControl = this.emailNotificationForm.get('notification_day')
    if (["2", "3"].includes(this.emailNotificationForm.value.notification_frequency)) {
      notificationDayControl.enable();
    } else {
      notificationDayControl.disable();
    }
  }

  getNotificationDayArray(): any[] {
    if (this.emailNotificationForm.value.notification_frequency == "2") {
      return [
        { id: 0, name: "Monday" },
        { id: 1, name: "Tuesday" },
        { id: 2, name: "Wenesday" },
        { id: 3, name: "Thursday" },
        { id: 4, name: "Friday" },
        { id: 5, name: "Saturday" },
        { id: 6, name: "Sunday" },
      ]
    } else if (this.emailNotificationForm.value.notification_frequency == "3") {
      const notificationDayArray = []
      for (let i = 1; i <= 31; i++) {
        notificationDayArray.push(
          { id: i, name: String(i) },
        )
      }

      return notificationDayArray
    } else {
      return []
    }
  }

  validateEmails(): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emailControl = this.emailNotificationForm.get("email_address");
    const emails = emailControl.value.split(',').map(email => email.trim());
    const isValid = emails.every(email => email ? emailRegex.test(email) : true);
    
    if (isValid) {
      emailControl.setErrors(null); // ✅ Clear error on the control
    } else {
      emailControl.setErrors({ invalidEmail: true }); // ✅ Set error on the control
    }

    emailControl.markAsTouched(); // Optional: ensures the error displays immediately
    return isValid;
  }

}
